import { getItemById } from '../ducks/data'

export const addRelatedBindings = (bindings, state, app) => {
  let newBindings = {}

  for (let key of Object.keys(bindings)) {
    let { datasources } = app
    let [datasourceId, tableId] = key.split('.')

    if (datasources[datasourceId].tables) {
      let table = datasources[datasourceId].tables[tableId]

      let referenceFields = Object.keys(table.fields).filter(
        fieldId => table.fields[fieldId].type.type === 'belongsTo'
      )

      let record = getItemById(state, tableId, bindings[key])

      referenceFields.map(fieldId => {
        let { tableId } = table.fields[fieldId].type
        let key = `${datasourceId}.${tableId}`

        if (!newBindings[key]) {
          newBindings[key] = record[fieldId]
        }
      })
    }
  }

  return { ...newBindings, ...bindings }
}

/**
 * Determine if a binding contains a random formula
 * @param {object | object[]} binding
 * @returns {boolean} boolean
 */
export const doesBindingContainRandomFormula = binding => {
  if (!binding) return false

  if (Array.isArray(binding)) {
    return binding.some(b => doesBindingContainRandomFormula(b))
  }

  if (!binding.parsedFormula || !Array.isArray(binding.parsedFormula)) {
    return false
  }

  return binding.parsedFormula.includes('random')
}
